<div id="content">
  <div class="page-title">
    <app-company-product-page-identity />
    <h1>{{ page_title }}</h1>
  </div>
  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      @if (isWorker) {
        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="company_product_phase_stage_id">
            <mat-option [value]="''">Todos</mat-option>
            <mat-option [value]="'is_active'">Activos</mat-option>
            @for (s of company_product_phase_stages; track s) {
              <mat-option [value]="s.id">
                {{ s.title }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field>
        <input matInput type="text" formControlName="search" />
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>
    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="col-type">Nombre</th>
          <td mat-cell *matCellDef="let companyProductPhase" class="col-type">
            @if (isWorker) {
              @if (can_act_as_product_manager()) {
                <span
                  ><a
                    [routerLink]="[
                      '/employees',
                      'development',
                      'company-products',
                      companyProductPhase.company_product_id,
                      'phases',
                      companyProductPhase.id,
                      'backlog',
                    ]"
                    >{{ companyProductPhase.company_product_phase_type.name }}</a
                  ></span
                >
              } @else {
                <span
                  ><a
                    [routerLink]="[
                      '/employees',
                      'development',
                      'company-products',
                      companyProductPhase.company_product_id,
                      'phases',
                      companyProductPhase.id,
                      'boards',
                    ]"
                    >{{ companyProductPhase.company_product_phase_type.name }}</a
                  ></span
                >
              }
            } @else if (isClient) {
              <span
                ><a
                  [routerLink]="[
                    '/clients',
                    'company-products',
                    companyProductPhase.company_product_id,
                    'phases',
                    companyProductPhase.id,
                    'boards',
                  ]"
                  >{{ companyProductPhase.company_product_phase_type?.name }}</a
                ></span
              >
            } @else if (isPartner) {
              <span
                ><a
                  [routerLink]="['/partners', 'company-products', companyProductPhase.company_product_id, 'phases', companyProductPhase.id]"
                  >{{ companyProductPhase.company_product_phase_type.name }}</a
                ></span
              >
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="team">
          <th mat-header-cell *matHeaderCellDef class="col-team">Equipo</th>
          <td mat-cell *matCellDef="let companyProductPhase" class="col-team">
            @if (companyProductPhase.company_product_team; as team) {
              <a href="#" (click)="openTeamMembersDialog(team, $event)">{{ team.name }}</a>
            } @else {
              Sin asignar
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="week-progress">
          <th mat-header-cell *matHeaderCellDef class="col-week-progress" [matTooltip]="'Calculado cada 1h (cached)'">
            Progreso semanal de equipo
          </th>
          <td mat-cell *matCellDef="let companyProductPhase" class="col-week-progress">
            @if (companyProductPhase.company_product_phase_type.weekly_hours_requirement !== WeeklyHoursRequirement.FLEXIBLE) {
              @if (weekly_progress_loading && !companyProductPhase.weekly_progress_cached) {
                <div class="week-progress-row">
                  <mat-progress-bar
                    class="week-progress-bar"
                    mode="indeterminate"
                    color="accent"
                    matTooltip="Cargando progreso semanal..."
                  ></mat-progress-bar>
                </div>
              } @else if (companyProductPhase.weekly_progress_cached) {
                <div class="week-progress-row">
                  <mat-progress-bar
                    class="week-progress-bar"
                    mode="determinate"
                    color="accent"
                    [matTooltip]="
                      (companyProductPhase.weekly_progress_cached.done_hours * 3600 | secondsToStringTime) +
                      ' registradas de ' +
                      (companyProductPhase.weekly_progress_cached.expected_hours_budgetable * 3600 | secondsToStringTime)
                    "
                    [value]="
                      (companyProductPhase.weekly_progress_cached.done_hours /
                        companyProductPhase.weekly_progress_cached.expected_hours_budgetable) *
                      100
                    "
                  ></mat-progress-bar>
                  <span class="week-progress-label">
                    <span matTooltip="Horas registradas">
                      {{ companyProductPhase.weekly_progress_cached.done_hours * 3600 | secondsToStringTime }} /
                    </span>
                    <span matTooltip="Horas mínimas esperadas">
                      {{ companyProductPhase.weekly_progress_cached.expected_hours_budgetable * 3600 | secondsToStringTime }}
                    </span>
                  </span>
                </div>
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="col-actions"></th>
          <td mat-cell *matCellDef="let CompanyProductPhase; let i = index" class="col-actions">
            @if (can_act_as_product_manager()) {
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openEditCompanyProductPhaseDialog(CompanyProductPhase)">
                  <mat-icon style="margin-right: 10px">edit</mat-icon>
                  Editar fase
                </button>
              </mat-menu>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
